import MealPlanScreen from "@/screens/MealPlanScreen";

export default MealPlanScreen;
